module.exports = __webpack_public_path__ + "img/index-honor11.ef91a2dc.png";